<template>
  <AddSize />
</template>

<script>
import AddSize from '@/components/product/stockModules/addSize.vue'
export default {
  components: {
    AddSize,
  },
}
</script>
